class PaymentPlansContextIsNotInitialized extends Error {
    constructor() {
        super('usePaymentPlans must be used within a PaymentPlansProvider');
    }
}
export default PaymentPlansContextIsNotInitialized;
